<div class="betbuilder-button">
    <button
        ds-button
        msThemedButton
        kind="primary"
        variant="filled"
        size="medium"
        [themeKind]="buttonThemeKind"
        [themeVariant]="buttonThemeVariant"
        [themeSize]="buttonThemeSize"
        [class.in-top-events]="buttonSource === buttonSources.TopEvents"
        (click)="openBetBuilder()">
        {{ btnText$ | async }}
    </button>
</div>

<ng-template #header>
    <ms-betbuilder-overlay-header
        [eventName]="event.name"
        [sportId]="event.sport.id"
        [leagueId]="event.league.id"
        [eventId]="event.id"
        [eventStartDate]="event.startDate"
        [eventParticipants]="event.participants"
        [eventViewType]="event.viewType" />
</ng-template>
